import { PaymentPlan } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';
import { WithPaymentPlanId } from '../PaymentPlans/types';
import { PAYMENT_TYPES_MANUAL_PAYMENT } from '../PaymentPlans/const';
import { getEnabledPaymentMethodId } from '../PaymentPlans/utils';
import { ProcessPaymentDialogButton } from '../../forms/ProcessPayment/ProcessPaymentDialogButton';
import { PaymentRequestType } from '../../forms/ProcessPayment/PaymentRequestForm/schema';

export const PaymentPlanDetailsOverviewTableHeaderActions = ({
    reservationId,
    accountId,
    paymentPlanId,
    paymentMethodData,
}: {
    reservationId: PaymentPlan['reservationId'];
    paymentMethodData?: PaymentPlan['paymentMethodData'];
} & WithAccountId &
    WithPaymentPlanId) => (
    <ProcessPaymentDialogButton
        buttonIcon
        accountId={accountId}
        allowedPaymentTypes={PAYMENT_TYPES_MANUAL_PAYMENT}
        defaultSelectedFormValues={{
            paymentPlanId,
            serviceOrderId: reservationId,
            paymentMethodId: getEnabledPaymentMethodId(paymentMethodData),
        }}
        readOnlyFormFields={{ isPaymentPlanIdReadOnly: true }}
        allowedPaymentRequestTypeOptions={[PaymentRequestType.PaymentMethod, PaymentRequestType.Payment]}
    />
);
